// extracted by mini-css-extract-plugin
module.exports = {"box":"_32bbee5fda--box--HW1Bz","round-icon":"_32bbee5fda--round-icon--BVZVa","box-header":"_32bbee5fda--box-header--ziiZt","box-description":"_32bbee5fda--box-description--QP_FP"};